import React, { Component } from 'react'
import Activity from "framework/containers/Activity"

//redux
import { connect } from 'react-redux'
import { mapStateToProps, mapDispatchToProps } from 'framework/utils/Redux'

class SalesMemberActivity extends Component {

	constructor(props){
		super(props)
		this.RenderedComponent = import("app/components/Accounting/Partner/PartnerBrowser")
	}

	render() {
		return (
			<Activity 
				name="SalesMember"
				RenderedComponent={this.RenderedComponent}
				context="SalesMember"
			/>
		)
	}
}

export default connect(mapStateToProps,mapDispatchToProps)(SalesMemberActivity)
